(() => {
  const sectionName = 'images-and-text';

  if (sectionName in Shopify.theme.sections.registered) {
    const sections = document.querySelectorAll(`[data-section-type=${sectionName}]`);

    sections.forEach((section, index) => {
      if (index !== 0) {
        const linkTag = section.querySelector('link');
        const scriptTag = section.querySelector('script');

        linkTag?.remove();
        scriptTag?.remove();
      }
    });
  } else {
    const selectors = {
      section: '.images-and-text',
      body: 'body',
      overflowVideo: '.overflow-video-wrapper',
      videoModalOpenButton: '.js-images-and-text__content-link',
      videoModalCloseButton: '.js-images-and-text__video-modal-button',
      videoModalWrapper: '.images-and-text__video-modal-wrapper',

      bodyOverflowClass: 'body--overflow',
      overflowVideoActiveClass: 'overflow-video-wrapper--active',
      videoModalWrapperActiveClass: 'images-and-text__video-modal-wrapper--active',
    };

    const videoModalButton = document.querySelectorAll(selectors.videoModalOpenButton);
    const videoCloseButton = document.querySelectorAll(selectors.videoModalCloseButton);

     function closeVideoModal(event) {
       const section = event.currentTarget.closest(selectors.section);
       const body = document.querySelector(selectors.body);
       const overflowVideo = document.querySelector(selectors.overflowVideo);
       const videoModalWrapper = section.querySelector(selectors.videoModalWrapper);

       if (videoModalWrapper) {
         videoModalWrapper.classList.remove(selectors.videoModalWrapperActiveClass);
         body.classList.remove(selectors.bodyOverflowClass);
         overflowVideo.classList.remove(selectors.overflowVideoActiveClass);
         const iframe = videoModalWrapper.querySelector('iframe');
         const videoUrl = iframe.getAttribute('src');

         iframe.setAttribute('src', '');
         iframe.setAttribute('src', videoUrl);
       };
     };

     function openVideoModal(event) {
       const section = event.currentTarget.closest(selectors.section);
       const body = document.querySelector(selectors.body);
       const overflowVideo = document.querySelector(selectors.overflowVideo);
       const videoModalWrapper = section.querySelector(selectors.videoModalWrapper);

       if (videoModalWrapper) {
         videoModalWrapper.classList.add(selectors.videoModalWrapperActiveClass);
         body.classList.add(selectors.bodyOverflowClass);
         overflowVideo.classList.add(selectors.overflowVideoActiveClass);
       };
     };

     videoModalButton.forEach((button) => {button.addEventListener('click', openVideoModal);});

     videoCloseButton.forEach((element) => {element.addEventListener('click', closeVideoModal);});

    Shopify.theme.sections.register(sectionName);
  }
})();
